export const mockPosts = [
  {
    id: "1",
    author: "Dr. Amara Osei",
    avatar: "https://public.readdy.ai/ai/img_res/3fe080580edccae389656cc8c894c527.jpg",
    niche: "Mindset Coach",
    title: "Breaking the Scarcity Mindset: My 30-Day Journey",
    content: "After years of coaching hundreds of clients, I discovered that the #1 block to success isn't skill — it's the scarcity mindset. Here's the framework I use to help clients shift from lack to abundance in just 30 days...",
    image: "https://readdy.ai/api/search-image?query=abundance%20mindset%20transformation%20journey%20abstract%20colorful%20uplifting%20artistic%20digital%20painting%20warm%20tones&width=600&height=400&seq=post1&orientation=landscape",
    rating: 4.9,
    ratingCount: 87,
    comments: 34,
    likes: 214,
    tags: ["Mindset", "Abundance", "Transformation"],
    timeAgo: "2 hours ago",
  },
  {
    id: "2",
    author: "Marcus Elliot",
    avatar: "https://readdy.ai/api/search-image?query=professional%20black%20man%20business%20coach%20confident%20portrait%20clean%20background&width=80&height=80&seq=av2&orientation=squarish",
    niche: "Career Coach",
    title: "The 5 Questions That Changed My Clients' Careers",
    content: "Most career advice focuses on what to do. But the real breakthroughs happen when you ask the right questions. These 5 powerful questions have helped over 200 of my clients land roles they never thought possible...",
    image: "https://readdy.ai/api/search-image?query=career%20success%20questions%20strategy%20professional%20growth%20abstract%20geometric%20gold%20dark%20background&width=600&height=400&seq=post2&orientation=landscape",
    rating: 4.8,
    ratingCount: 63,
    comments: 28,
    likes: 178,
    tags: ["Career", "Strategy", "Growth"],
    timeAgo: "5 hours ago",
  },
  {
    id: "3",
    author: "Sophia Hartmann",
    avatar: "https://readdy.ai/api/search-image?query=professional%20european%20woman%20executive%20coach%20portrait%20clean%20studio%20background&width=80&height=80&seq=av3&orientation=squarish",
    niche: "Corporate Coach",
    title: "Why Most Leaders Fail at Emotional Intelligence",
    content: "In 15 years of corporate coaching, I've seen brilliant executives derail their careers because of one thing: emotional intelligence gaps. Here's what the research says and how to fix it...",
    image: "https://readdy.ai/api/search-image?query=leadership%20emotional%20intelligence%20corporate%20team%20abstract%20professional%20dark%20teal%20geometric%20modern&width=600&height=400&seq=post3&orientation=landscape",
    rating: 4.9,
    ratingCount: 112,
    comments: 51,
    likes: 302,
    tags: ["Leadership", "EQ", "Corporate"],
    timeAgo: "1 day ago",
  },
  {
    id: "4",
    author: "Kenji Nakamura",
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20man%20life%20coach%20smiling%20portrait%20warm%20background&width=80&height=80&seq=av4&orientation=squarish",
    niche: "Life Coach",
    title: "Designing Your Ideal Life: A Visual Framework",
    content: "Most people live by default, not by design. After coaching 500+ clients, I developed this visual life design framework that helps you see your life as a whole and make intentional choices...",
    image: "https://readdy.ai/api/search-image?query=life%20design%20vision%20board%20colorful%20creative%20planning%20artistic%20abstract%20warm%20golden%20tones&width=600&height=400&seq=post4&orientation=landscape",
    rating: 4.7,
    ratingCount: 94,
    comments: 42,
    likes: 256,
    tags: ["Life Design", "Vision", "Purpose"],
    timeAgo: "2 days ago",
  },
  {
    id: "5",
    author: "Layla Hassan",
    avatar: "https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20woman%20coach%20confident%20portrait%20studio%20warm%20tones&width=80&height=80&seq=av5&orientation=squarish",
    niche: "Confidence Coach",
    title: "The Confidence Paradox: Why Trying Harder Backfires",
    content: "Here's the counterintuitive truth about confidence: the harder you try to feel confident, the less confident you feel. After years of research and coaching, I've found the real path to unshakeable self-belief...",
    image: "https://readdy.ai/api/search-image?query=confidence%20empowerment%20woman%20silhouette%20sunrise%20golden%20light%20abstract%20artistic%20uplifting%20warm&width=600&height=400&seq=post5&orientation=landscape",
    rating: 4.8,
    ratingCount: 78,
    comments: 39,
    likes: 198,
    tags: ["Confidence", "Self-Belief", "Mindset"],
    timeAgo: "3 days ago",
  },
  {
    id: "6",
    author: "Dr. Priya Sharma",
    avatar: "https://readdy.ai/api/search-image?query=professional%20indian%20woman%20wellness%20coach%20smiling%20portrait%20clean%20background&width=80&height=80&seq=av6&orientation=squarish",
    niche: "Wellness Coach",
    title: "The Science of Stress Resilience: What Actually Works",
    content: "Stress is inevitable. Suffering is optional. As a wellness coach with a background in neuroscience, I've compiled the most evidence-based strategies for building genuine resilience — not just coping...",
    image: "https://readdy.ai/api/search-image?query=wellness%20resilience%20calm%20meditation%20nature%20water%20reflection%20serene%20peaceful%20abstract%20teal%20green&width=600&height=400&seq=post6&orientation=landscape",
    rating: 4.6,
    ratingCount: 55,
    comments: 23,
    likes: 143,
    tags: ["Wellness", "Resilience", "Science"],
    timeAgo: "4 days ago",
  },
];

export const mockComments = [
  {
    id: "c1",
    postId: "1",
    author: "Jordan Lee",
    avatar: "https://readdy.ai/api/search-image?query=young%20professional%20person%20smiling%20portrait%20clean%20background&width=40&height=40&seq=cav1&orientation=squarish",
    content: "This completely changed how I approach my morning routine. The abundance journaling exercise alone is worth it!",
    timeAgo: "1 hour ago",
    likes: 12,
  },
  {
    id: "c2",
    postId: "1",
    author: "Aisha Mensah",
    avatar: "https://readdy.ai/api/search-image?query=young%20african%20woman%20smiling%20portrait%20clean%20background&width=40&height=40&seq=cav2&orientation=squarish",
    content: "Dr. Osei, your work has been transformational for me. I went from constant anxiety about money to feeling genuinely abundant. Thank you!",
    timeAgo: "2 hours ago",
    likes: 8,
  },
];
